import TableComponent, {
  IColumnProps,
} from '../../../components/TableComponent';
import { useGetAllLicensesAsync } from '../../../services/LicenseService/hooks/useMutations';
import React, { useEffect, useState } from 'react';
import { ILicenseSimpleProps } from '../../../services/LicenseService/types';
import ButtonComponent from '../../../components/ButtonComponent';
import { Add } from '@mui/icons-material';
import ButtonActionsComponent from '../../../components/ButtonActionsComponent';
import { Box } from '@mui/material';
import SchoolTransportationEditionModal from './SchoolShiftEditionModal';
import ConfirmDeleteModalComponent from '../../../components/ConfirmDeleteModalComponent';
import { IPaginationParams } from '../../../services/types';
import { ILprDeviceFilterProps } from '../../../services/Devices/LprService/types';
import SchoolShiftEditionModal from './SchoolShiftEditionModal';
import {
  useDeleteSchoolShiftAsync,
  useGetAllSchoolShiftByLicenseAsync,
  useGetSchoolShiftByIdAsync,
} from '../../../services/SchoolShift/hooks/useMutation';
import {
  ISchoolShiftProps,
  ISchoolShiftSimpleProps,
} from '../../../services/SchoolShift/types';
const LicensesList = () => {
  const [schoolTransportation, setSchoolTransportation] = useState<
    ISchoolShiftSimpleProps[]
  >([]);
  const [isVisibleEditionModal, setIsVisibleEditionModal] =
    useState<boolean>(false);
  const [selectedItemToDelete, setSelectedItemToDelete] =
    useState<ISchoolShiftSimpleProps>();
  const [responsibleToEdit, setResponsibleToEdit] = useState<
    ISchoolShiftProps | undefined
  >(undefined);
  const [isVisibleDeleteItemModal, setIsVisibleDeleteItemModal] =
    useState<boolean>(false);
  const [pagination, setPagination] = useState<IPaginationParams>({
    pageNumber: 1,
    pageSize: 10,
  });
  const [filter, setFilter] = useState<ILprDeviceFilterProps>({
    name: '',
  });
  const { mutateAsync, reset } = useGetAllSchoolShiftByLicenseAsync();
  const { mutateAsync: mutateResponsibleAsync } = useGetSchoolShiftByIdAsync();
  const {
    mutateAsync: mutateDeleteResponsibleAsync,
    isLoading: isLoadingDeleteResponsible,
  } = useDeleteSchoolShiftAsync();
  const columns: IColumnProps[] = [
    {
      id: 'name',
      label: 'Nome',
      width: '40%',
    },
    {
      id: 'id',
      label: 'Ações',
      align: 'center',
      width: 'min',
      render: (id) => (
        <ButtonActionsComponent
          key={id}
          isWithDefaultOptionsList
          handleDelete={() => handleDeleteItem(Number(id))}
          handleEdit={() => handleEdit(Number(id))}
        />
      ),
    },
  ];

  useEffect(() => {
    mutateAsync().then(setSchoolTransportation);
  }, []);
  const handleDeleteItem = async (id: number) => {
    const responsible: any = await mutateResponsibleAsync(id);
    setSelectedItemToDelete(responsible);
    setIsVisibleDeleteItemModal(true);
  };

  const handleEdit = (id: number) => {
    mutateResponsibleAsync(id).then(setResponsibleToEdit);
    setIsVisibleEditionModal(true);
  };
  const refetchResponsible = () => {
    mutateAsync().then(setSchoolTransportation);
  };
  const handleConfirmDeletion = () => {
    if (selectedItemToDelete?.id)
      mutateDeleteResponsibleAsync(selectedItemToDelete?.id).then(() => {
        setPagination((oldStt) => ({ ...oldStt, pageNumber: 1 }));
        setIsVisibleDeleteItemModal(false);
        refetchResponsible();
      });
  };
  const handleCancelDeletion = () => {
    setIsVisibleDeleteItemModal(false);
    setSelectedItemToDelete(undefined);
  };
  return (
    <>
      <TableComponent
        additionalTitleComponent={
          <ButtonComponent
            onClick={() => setIsVisibleEditionModal(true)}
            startIcon={<Add />}
          >
            Novo Turno
          </ButtonComponent>
        }
        title="Turno Escolar"
        rows={schoolTransportation}
        columns={columns}
      />
      <ConfirmDeleteModalComponent
        isLoading={isLoadingDeleteResponsible}
        isVisibleDeleteDialog={isVisibleDeleteItemModal}
        setIsVisibleDeleteDialog={setIsVisibleDeleteItemModal}
        title={'Excluir Turno'}
        message={`Tem certeza que deseja excluir este turno "${selectedItemToDelete?.name}"?`}
        handleCancelDeletion={handleCancelDeletion}
        handleConfirmDeletion={handleConfirmDeletion}
      />
      <SchoolShiftEditionModal
        handleSaveForm={() => mutateAsync().then(setSchoolTransportation)}
        responsibleEdit={responsibleToEdit}
        isOpen={isVisibleEditionModal}
        setIsOpen={setIsVisibleEditionModal}
      />
    </>
  );
};

export default LicensesList;
